


import React, { createContext, useContext, useState, useEffect } from 'react';
import {jwtDecode} from 'jwt-decode';

const RoleContext = createContext();

export const useRole = () => useContext(RoleContext);

export const RoleProvider = ({ children }) => {
    const [role, setRole] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                setRole(decodedToken.role || null); // Set the role from the decoded token
            } catch (error) {
                console.error('Invalid token:', error);
                setRole(null);
            }
        } else {
            setRole(null);
        }
    }, []); 

    return (
        <RoleContext.Provider value={{ role, setRole }}>
            {children}
        </RoleContext.Provider>
    );
};